import { Control } from "rete";
import DropdownComponent from "./dropdown-component";

export class DropdownControl extends Control {
  constructor(emitter, key, type, readonly, placeholder, comp) {
    super(key);
    this.component = DropdownComponent;
    this.props = {
      comp,
      emitter,
      ikey: key,
      placeholder,
      readonly,
      type
    };
  }

  setValue(value) {
    this.vueContext.value = value;
  }
}
